import { Namespace, TFunction } from 'react-i18next';
import * as Yup from 'yup';

import { LimitOwnerType } from '@app/models/products';

import { IFormValues } from './interfaces';

export const ValidationSchema = (t: TFunction<Namespace<'validation'>>): Yup.SchemaOf<IFormValues> =>
  Yup.object().shape({
    limit_owner_type: Yup.mixed<LimitOwnerType>().required(t('required')),
    limit_owner_uid: Yup.object()
      .shape({
        value: Yup.mixed<string | number>().required(t('required')),
        label: Yup.string().required(t('required')),
      })
      .required(t('required')),
  });
